export const LICENSE_ERROR_CODE = "APP-5031";
export const LICENSE_ERROR_EVENT = "kaizen-license-error";
export const LICENSE_ERROR_MESSAGE =
  "Error en la aplicación.\nCódigo de error: APP-5031\nContacte a soporte.";

export const createLicenseNotificationGate = () => {
  let activeEpisode = false;

  return {
    processStatus(status) {
      if (status?.severity === "OK") {
        activeEpisode = false;
        return false;
      }

      if (!status || !["WARNING", "ERROR"].includes(status.severity)) return false;
      if (activeEpisode) return false;
      activeEpisode = true;
      return true;
    },
    processErrorCode(code) {
      if (code !== LICENSE_ERROR_CODE || activeEpisode) return false;
      activeEpisode = true;
      return true;
    },
    reset() {
      activeEpisode = false;
    },
  };
};

export const emitLicenseError = () => {
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent(LICENSE_ERROR_EVENT, { detail: { code: LICENSE_ERROR_CODE } })
    );
  }
};
